var exports = {
  "kL": "xa15a2ab7--1fef66--container",
  "$E": "xa15a2ab7--1fef66--container--fullscreen",
  "Sl": "xa15a2ab7--1fef66--image",
  "o1": "xa15a2ab7--1fef66--actions",
};

module.exports = exports;
